import config from '../../../configuration/configuration.js';
import AxiosRequest from '../../../utils/AxiosRequest';

export const GenerateTemplateRequest = (fileLocation, userId, template) => AxiosRequest({
	method: 'GET',
	url: `${config.API_URL}Scripts/GenerateTemplate`,
	params: { fileLocation, userId, template }
});

export const GetTemplatesRequest = () => AxiosRequest({
	method: 'GET',
	url: `${config.API_URL}Scripts/GetTemplates`,
	params: { }
});

export const GenerateCellInfoRequest = (fileLocation, userId) => AxiosRequest({
	method: 'GET',
	url: `${config.API_URL}Scripts/GenerateCellInfo`,
	params: { fileLocation, userId }
});
